"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorCollectionList = void 0;
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const classnames_1 = require("../../util/classnames");
const topological_editor_collection_list_style_1 = require("./topological.editor.collection.list.style");
(0, theme_1.addStyles)(topological_editor_collection_list_style_1.Style);
exports.TopologicalEditorCollectionList = {
    view(options) {
        return (0, mithril_1.m)('div', { className: topological_editor_collection_list_style_1.CSS.container }, options.collections.map((pole) => pole
            ? (0, mithril_1.m)('div', {
                className: (0, classnames_1.classNames)(topological_editor_collection_list_style_1.CSS.item, {
                    [topological_editor_collection_list_style_1.CSS.selected]: options.selectedRevision === pole.revision,
                    [topological_editor_collection_list_style_1.CSS.noLocation]: !pole.location,
                }),
                role: 'button',
                tabindex: '0',
                onclick: () => options.onItemClick(pole.revision),
            }, [
                (0, mithril_1.m)('div', {
                    className: (0, classnames_1.classNames)({
                        [topological_editor_collection_list_style_1.CSS.unsaved]: options.collectionsEditController.collectionHasChanges(pole.revision),
                    }),
                }, [
                    pole.title ? pole.title : (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE),
                    pole.isMissingTrueSize() ? (0, mithril_1.m)('span', { className: topological_editor_collection_list_style_1.CSS.redDot }) : null,
                ]),
                (0, mithril_1.m)('div', {
                    className: topological_editor_collection_list_style_1.CSS.info,
                }, options.collectionsEditController.collectionHasChanges(pole.revision)
                    ? `(${(0, i18n_1.Translate)(i18n_1.T.TOPO_UNSAVED_COLLECTION)})`
                    : ''),
            ])
            : null));
    },
};
//# sourceMappingURL=topological.editor.collection.list.js.map